'use client';

import { c } from 'ui-components';
import { Skeleton } from './Skeleton';

type QuerySummarySkeletonProps = {
  variant?: 'title' | 'count' | 'full';
  className?: string;
};

export const QuerySummarySkeleton = ({
  variant = 'full',
  className,
}: QuerySummarySkeletonProps) => {
  if (variant === 'title') {
    return <Skeleton className={c('h-7 w-48 animate-pulse', className)} />;
  }

  if (variant === 'count') {
    return <Skeleton className={c('h-5 w-32 animate-pulse', className)} />;
  }

  // Full variant
  return (
    <div className={c('animate-pulse', className)}>
      <Skeleton className="mb-4 h-7 w-48 lg:mb-6" />
      <Skeleton className="h-5 w-32" />
    </div>
  );
};
